import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CaseDisplayGroup } from "generated/graphql";

type GroupLocationNamesProps = {
  propertyKey: string;
  groupsByLocationName: Map<string, CaseDisplayGroup[]>;
};

// Display itemized list in tooltip text for locations/groups impacted by property removal
// Default to "No Locations" if groups do not appear anywhere
export const GroupLocationNames = ({ propertyKey, groupsByLocationName }: GroupLocationNamesProps) => {
  return (
    <div key={propertyKey} className="mb-4">
      <div className="flex items-center space-x-1 font-bold">
        <span>{propertyKey}</span>
        <Tooltip
          title={
            <ul className="list-inside text-sm p-2">
              {groupsByLocationName.size > 0 ? (
                [...groupsByLocationName].map(([locationName, locationGroups]) => (
                  <li key={locationName}>
                    <b>{locationName}</b>
                    <ul className="list-disc list-inside pl-4">
                      {locationGroups.map((group) => (
                        <li key={group.id}>
                          <i>{group.name}</i>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))
              ) : (
                <div className="text-sm">No Locations</div>
              )}
            </ul>
          }
          arrow>
          <InfoOutlinedIcon fontSize="small" color="action" className="cursor-help" />
        </Tooltip>
      </div>
    </div>
  );
};
